/**
 * Created by linjianxi on 2016/10/25.
 */

import * as reflectService from '../../../api/reflectService'

export const getReflectList = ({ commit }, oparams) => {
  reflectService.getReflectData(oparams.type, oparams.pageIndex, oparams.pageSize)
    .then(res => {
      console.log(res.data)
      commit('GET_REFLECT_LIST', res.data)
    })
    .catch(res => {
      alert('请求服务器失败,请稍等')
    })
}



// WEBPACK FOOTER //
// ./src/vuex/modules/reflect/actions.js